import axios from 'axios';

let initialized = false;
let onApiError = null;

const buildErrorMessage = (error) => {
  const payload = error?.response?.data;

  if (typeof payload === 'string' && payload.trim()) {
    return payload;
  }

  if (payload?.message) {
    return payload.message;
  }

  if (payload?.error) {
    return payload.error;
  }

  return error?.message || 'Something went wrong.';
};

export const setApiErrorHandler = (handler) => {
  onApiError = handler;
};

export const initializeApiInterceptors = () => {
  if (initialized) {
    return;
  }

  axios.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem('token');
      config.headers = config.headers || {};

      if (!config.headers.env) {
        config.headers.env = 'local';
      }

      if (token && !config.headers.token) {
        config.headers.token = token;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (onApiError) {
        onApiError(buildErrorMessage(error));
      }
      return Promise.reject(error);
    }
  );

  initialized = true;
};
